import axios from "axios";
import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Badge,
  Col,
  Divider,
  Icon,
  Input,
  Modal,
  Pagination,
  Radio,
  Row,
  Select,
  Spin,
  Table,
  Tooltip,
  message,
} from "antd";
import {
  ADD_PATIENT_DETAILS,
  SETCURRENTPAGEANDSIZE,
  SET_FETCH_ORDER,
  SET_FETCH_PARTNERS,
  UPDATE_ORDER,
} from "../../ActionTypes/ActionTypes";
import "./FetchOrderList.css";

const { confirm } = Modal;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const { Search } = Input;
const { Option } = Select;

let timeout;
let currentValue;

function fetch(value, callback) {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  }
  currentValue = value;

  function fake() {
    axios({
      method: "get",
      url: `/doctors/lookup_doctors.json?name=${value}`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    }).then((d) => {
      let matchedList;
      if (currentValue === value) {
        matchedList = d.data;
      }
      callback(matchedList);
    });
  }

  timeout = setTimeout(fake, 300);
}

class FetchOrderList extends Component {
  state = {
    loading: false,
    edit_order_id: "",
    dispenser_size: "",
    order_language: "",
    location: "",
    location_id: "",
    orderLength: 0,
    partner_reference_number: "",
    searchValue: "",
    pageNo: 1,
    size: 10,
    selectSearchOption: "name",
    discount_percentage: "",
    // doc status
    docSearchValue: "",
    doctor_id: "",
    docFetching: false,
    docList: [],
    dummy: [],
  };

  /* eslint-disable func-names */
  typewatch = (function () {
    let timer = 0;
    return function (callback, ms) {
      clearTimeout(timer);
      timer = setTimeout(callback, ms);
    };
  })();

  componentDidMount = () => {
    this.getOrder();
    this.getOrderCount();
    this.loadPartners();
  };

  getOrder = () => {
    const { pageNo, pageSize } = this.props;
    const { history, setOrders } = this.props;

    this.setState({
      loading: true,
    });
    axios({
      method: "get",
      url: `/orders.json?page=${pageNo}&page_size=${pageSize}`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    })
      .then((response) => {
        console.log(response.data);
        setOrders(response.data);
        this.setState({
          loading: false,
        });
      })
      .catch(() => {
        history.push("/login");
      });
  };

  loadPartners = () => {
    const { setPartners } = this.props;

    axios({
      method: "get",
      url: "/partners.json",
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    })
      .then((response) => {
        setPartners(response.data);
      })
      .catch((error) => {
        alert(
          `Internet Not working, Please check you connection: ${error.code}`
        );
      });
  };

  getOrderCount = () => {
    this.setState({ loading: true });
    axios({
      method: "get",
      url: "/orders/orders_count",
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    }).then((response) => {
      this.setState({
        orderLength: response.data.orders_count,
        loading: false,
      });
    });
  };

  onShowSizeChange = (current, pageSize) => {
    const { setOrders, setCurrenetPageAndSize } = this.props;

    setCurrenetPageAndSize(current, pageSize);

    this.setState({
      loading: true,
      pageNo: current,
      size: pageSize,
    });
    axios({
      method: "get",
      url: `/orders.json?page=${current}&page_size=${pageSize}`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    }).then((response) => {
      setOrders(response.data);
      this.setState({
        loading: false,
      });
    });
  };

  onChange = (current, pageSize) => {
    const { setOrders, setCurrenetPageAndSize } = this.props;

    setCurrenetPageAndSize(current, pageSize);
    // const { pageSize, pageNo } = this.props;

    this.setState(
      {
        loading: true,
        searchValue: "",
        pageNo: current,
        size: pageSize,
      },
      () => {
        axios({
          method: "get",
          url: `/orders.json?page=${current}&page_size=${pageSize}`,
          headers: { Authorization: sessionStorage.getItem("jwtToken") },
        }).then((response) => {
          setOrders(response.data);
          this.setState({
            loading: false,
          });
        });
      }
    );
  };

  // Searching starts here

  onSearchChange = (event) => {
    this.setState({
      selectSearchOption: event.target.value,
    });
  };

  onSearchSubmit = (value) => {
    const { selectSearchOption } = this.state;
    const { setOrders } = this.props;

    this.setState({ fetching: true });
    if (selectSearchOption === "name") {
      axios({
        method: "get",
        url: `orders/search_by_name.json?name=${value}`,
        headers: { Authorization: sessionStorage.getItem("jwtToken") },
      }).then((response) => {
        setOrders(response.data);
        console.log(response.data);
        this.setState({
          fetching: false,
        });
      });
    } else if (selectSearchOption === "mobile") {
      axios({
        method: "get",
        url: `orders/search_by_mobile.json?mobile_number=${value}`,
        headers: { Authorization: sessionStorage.getItem("jwtToken") },
      }).then((response) => {
        setOrders(response.data);
        this.setState({
          fetching: false,
        });
      });
    }
  };

  changeSubmitValue = (event) => {
    if (event.target.value === "") {
      this.getOrder();
    }
    this.setState({ searchValue: event.target.value });
  };

  // searching ends here

  onOrderEdit = (record) => {
    this.setState({
      edit_order_id: record.id,
      dispenser_size: record.dispenser_size,
      location: record.partner_location.name,
      location_id: record.partner_location.id,
      order_type: record.order_type,
      doctor_id:
        record.onboarding_doctor == null ? "" : record.onboarding_doctor.id,
      partner_reference_number: record.partner_reference_number,
      order_language: record.order_language,
      status: record.status,
      reminder: record.reminder,
      discount_percentage: record.discount_percentage,
    });
  };

  onOrderSave = () => {
    const {
      edit_order_id,
      order_language,
      order_type,
      dispenser_size,
      location_id,
      partner_reference_number,
      reminder,
      status,
      discount_percentage,
      doctor_id,
    } = this.state;

    const { orders, updateOrder } = this.props;

    if (
      !isNaN(discount_percentage) ||
      (!isNaN(discount_percentage) &&
        discount_percentage.toString().indexOf(".") !== -1) ||
      discount_percentage == null ||
      discount_percentage.trim() === ""
    ) {
      this.setState({ loading: true });
      const order = orders.filter(
        (ord) => Number(ord.id) === Number(edit_order_id)
      )[0];
      const indexAt = orders.indexOf(order);

      // eslint-disable-next-line eqeqeq
      if (doctor_id == "") {
        axios({
          method: "put",
          url: `/orders/${edit_order_id}.json`,
          headers: { Authorization: sessionStorage.getItem("jwtToken") },
          data: {
            order: {
              order_type,
              order_language,
              dispenser_size,
              partner_location_id: location_id,
              partner_reference_number,
              reminder,
              status,
              discount_percentage,
            },
          },
        })
          .then((response) => {
            console.log(response.data);
            this.handleOnboardingLinking(doctor_id);
            updateOrder(indexAt, response.data);
            this.setState({
              loading: false,
              edit_order_id: "",
              dispenser_size: "",
              order_type: "",
              location_id: "",
              order_language: "",
              partner_reference_number: "",
              reminder: "",
              status: "",
              discount_percentage: "",
            });
            message.success("Order Updated Successfully");
          })
          .catch(() => {
            this.setState(
              {
                loading: false,
              },
              () => message.error("Problem! Please try again!")
            );
          });
      } else {
        axios({
          method: "post",
          url: `/orders/${edit_order_id}/onboard_doctor_link.json?doctor_id=${doctor_id}`,
          headers: { Authorization: sessionStorage.getItem("jwtToken") },
          data: {
            order: {
              doctor_id,
            },
          },
        })
          .then((res) => {
            console.log(res.data);
            this.setState({
              docSearchValue: "",
              doctor_id: "",
              docFetching: false,
              docList: [],
              dummy: [],
            });
            axios({
              method: "put",
              url: `/orders/${edit_order_id}.json`,
              headers: { Authorization: sessionStorage.getItem("jwtToken") },
              data: {
                order: {
                  order_type,
                  order_language,
                  dispenser_size,
                  partner_location_id: location_id,
                  partner_reference_number,
                  reminder,
                  status,
                  discount_percentage,
                },
              },
            })
              .then((response) => {
                console.log(response.data);
                updateOrder(indexAt, response.data);
                this.setState({
                  loading: false,
                  edit_order_id: "",
                  dispenser_size: "",
                  order_type: "",
                  location_id: "",
                  order_language: "",
                  partner_reference_number: "",
                  reminder: "",
                  status: "",
                  discount_percentage: "",
                });
                message.success("Order Updated Successfully");
              })
              .catch(() => {
                this.setState(
                  {
                    loading: false,
                  },
                  () => message.error("Problem! Please try again!")
                );
              });
          })
          .catch(() => {
            this.setState(
              {
                loading: false,
              },
              () => message.error("Problem! Please try again!")
            );
          });
      }
    } else {
      message.error("Enter valid discount");
    }
  };

  handleOnboardingLinking = (doctor_id) => {
    console.log(doctor_id);
  };

  handleDispenserSizeChange = (value) => {
    this.setState({
      dispenser_size: value,
    });
  };

  handlePartnerReferenceNumberChange = (event) => {
    this.setState({
      partner_reference_number: event.target.value,
    });
  };

  handleDiscountPercentageChange = (event) => {
    this.setState({
      discount_percentage: event.target.value,
    });
  };

  handleOrderLanguage = (value) => {
    this.setState({
      order_language: value,
    });
  };

  handleOrderTypeChange = (value) => {
    this.setState({
      order_type: value,
    });
  };

  handleReminderChange = (value) => {
    this.setState({
      reminder: value,
    });
  };

  handleStatusChange = (value) => {
    this.setState({
      status: value,
    });
  };

  handleLocationChange = (value, option) => {
    console.log(value, option);
    this.setState({
      location: value,
      location_id: Number(option.key),
    });
  };

  handleUserClick = (url, order_id, user_id, start_date, end_date) => {
    const { setOrderValuesInStore, history } = this.props;
    const id = order_id;
    setOrderValuesInStore({
      order_id,
      user_id,
      doctor_id: "",
      photo_link: "",
      start_date,
      end_date,
    });
    history.push(`/orders/${id}`);
  };

  handlePartnerClick = (url) => {
    const { history } = this.props;
    const id = url.split("/")[4].split(".")[0];
    // console.log(id);
    history.push(`/partners/${id}`);
  };

  showDeleteConfirm = (id) => {
    confirm({
      title: "Are you sure?",
      content:
        "This order will be deleted from the database & can not be recovered.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: () => {
        axios({
          method: "delete",
          url: `/orders/${id}.json`,
          headers: { Authorization: sessionStorage.getItem("jwtToken") },
        })
          .then((response) => {
            console.log(response.data);
            window.location.reload();
          })
          .catch((error) => console.log(error));
      },
      onCancel: () => {
        console.log("Cancel");
      },
    });
  };

  // doc handling
  handleDocSearch = (value) => {
    // console.log(value);
    this.setState({ docFetching: true });
    if (value.length > 2) {
      fetch(value, (docList) =>
        this.setState({
          docList,
          docFetching: false,
        })
      );
    }
  };

  handleDocChange = (value) => {
    this.setState({
      docSearchValue: value,
    });
  };

  handleDocSelect = (value) => {
    console.log(value);
    this.setState({ doctor_id: value });
  };

  render() {
    const {
      selectSearchOption,
      searchValue,
      loading,
      orderLength,
      order_language,
      order_type,
      dispenser_size,
      edit_order_id,
      location,
      partner_reference_number,
      reminder,
      status,
      discount_percentage,
      docList,
      dummy,
      docSearchValue,
      docFetching,
    } = this.state;

    const { orders, partners, pageNo } = this.props;

    const dispenserSizes = ["6 Old", "9 Old", "12", "9"];
    const orderTypes = ["Short Term", "Long Term", "Potential Long Term"];
    const orderLanguages = ["English", "Hindi"];
    const statuses = [
      "Active",
      "Inactive",
      "On Hold",
      "Treatment Complete",
      "Test",
      "Order Merged",
    ];

    const dispenserSizeOption = dispenserSizes.map((size) => (
      <Option key={size} value={size}>
        {size}
      </Option>
    ));

    const orderTypeOption = orderTypes.map((type) => (
      <Option key={type}>{type}</Option>
    ));

    const orderLanguageOption = orderLanguages.map((lang) => (
      <Option key={lang}>{lang}</Option>
    ));

    const statusesOption = statuses.map((sts) => (
      <Option key={sts}>{sts}</Option>
    ));

    const docOptions =
      docList === undefined
        ? dummy.map((d) => <Option key={d.id}>{d.name}</Option>)
        : docList.map((d) => <Option key={d.id}>{d.name}</Option>);

    const columns = [
      {
        title: "ID",
        dataIndex: "id",
        fixed: "left",
        width: 100,
        align: "center",
      },
      {
        title: "Name",
        fixed: "left",
        width: 200,
        render: (record) => (
          <span
            onClick={() =>
              this.handleUserClick(
                record.user.url,
                record.id,
                record.user.id,
                record.start_date,
                record.end_date
              )
            }
            role="button"
          >
            {record.user.is_vip === false ? (
              <a href="">
                {record.user.first_name} {record.user.last_name}
              </a>
            ) : (
              <span>
                <a href="">
                  {record.user.first_name} {record.user.last_name}
                </a>{" "}
                <Badge count="VIP" style={{ backgroundColor: "#52c41a" }} />
              </span>
            )}
            {record.p_prescriptions == null ? (
              ""
            ) : record.p_prescriptions.length > 0 ? (
              <span> (Rx)</span>
            ) : (
              ""
            )}
          </span>
        ),
      },
      {
        title: "Mobile Number",
        dataIndex: "user",
        render: (user) =>
          user.mobile_number == null ? "Not Provided" : `${user.mobile_number}`,
      },
      {
        title: "Partner ID",
        render: (record) =>
          Number(edit_order_id) !== Number(record.id) ? (
            record.partner_reference_number
          ) : (
            <Input
              value={partner_reference_number}
              onChange={this.handlePartnerReferenceNumberChange}
            />
          ),
      },
      {
        title: "Language",
        render: (record) =>
          Number(edit_order_id) !== Number(record.id) ? (
            record.order_language
          ) : (
            <Select
              showSearch
              style={{ width: 200 }}
              placeholder="Select one"
              value={order_language}
              optionFilterProp="children"
              onChange={(value) => this.handleOrderLanguage(value)}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {orderLanguageOption}
            </Select>
          ),
      },
      {
        title: "Status",
        render: (record) =>
          Number(edit_order_id) !== Number(record.id) ? (
            record.status
          ) : (
            <Select
              showSearch
              style={{ width: 200 }}
              placeholder="Select one"
              value={status}
              optionFilterProp="children"
              onChange={(value) => this.handleStatusChange(value)}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {statusesOption}
            </Select>
          ),
      },
      {
        title: "Reminder",
        render: (record) =>
          Number(edit_order_id) !== Number(record.id) ? (
            record.reminder ? (
              "True"
            ) : (
              "False"
            )
          ) : (
            <Select
              showSearch
              style={{ width: 200 }}
              placeholder="Select one"
              value={reminder}
              optionFilterProp="children"
              onChange={(value) => this.handleReminderChange(value)}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              <Option value>True</Option>
              <Option value={false}>False</Option>
            </Select>
          ),
      },
      {
        title: "Order Type",
        render: (record) =>
          Number(edit_order_id) !== Number(record.id) ? (
            record.order_type
          ) : (
            <Select
              showSearch
              style={{ width: 200 }}
              placeholder="Select one"
              value={order_type}
              optionFilterProp="children"
              onChange={(value) => this.handleOrderTypeChange(value)}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {orderTypeOption}
            </Select>
          ),
      },
      {
        title: "Location",
        render: (record) =>
          Number(edit_order_id) !== Number(record.id) ? (
            record.partner_location ? (
              record.partner_location.name
            ) : (
              "No Location"
            )
          ) : (
            <Select
              showSearch
              style={{ width: 200 }}
              placeholder="Select one"
              value={location}
              optionFilterProp="children"
              onChange={(value, id) => this.handleLocationChange(value, id)}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {partners
                .filter(
                  (part) => Number(part.id) === Number(record.partner.id)
                )[0]
                .partner_locations.map((loc) => (
                  <Option key={loc.id} value={loc.name}>
                    {loc.name}
                  </Option>
                ))}
            </Select>
          ),
      },
      {
        title: "Onboarding Point",
        render: (record) =>
          Number(edit_order_id) !== Number(record.id) ? (
            record.onboarding_doctor == null ? (
              ""
            ) : (
              record.onboarding_doctor.name
            )
          ) : (
            <Select
              showSearch
              value={docSearchValue}
              placeholder="Start typing Doctor name ..."
              style={{ width: 200 }}
              defaultActiveFirstOption={false}
              showArrow={false}
              filterOption={false}
              onSearch={this.handleDocSearch}
              onChange={this.handleDocChange}
              onSelect={this.handleDocSelect}
              notFoundContent={docFetching ? <Spin size="small" /> : null}
            >
              {docOptions}
            </Select>
          ),
      },
      {
        title: "Discount",
        width: "100",
        render: (record) =>
          Number(edit_order_id) !== Number(record.id) ? (
            record.discount_percentage == null ? (
              "No Discount"
            ) : (
              `${record.discount_percentage}%`
            )
          ) : (
            <Input
              placeholder="Discount Percentage"
              value={discount_percentage}
              onChange={this.handleDiscountPercentageChange}
            />
          ),
      },
      {
        title: "Order Date",
        render: (record) =>
          record.carefill_count === 0 ? "Yet to start" : record.start_date,
      },
      {
        title: "Dispenser Size",
        render: (record) =>
          Number(edit_order_id) !== Number(record.id) ? (
            record.dispenser_size
          ) : (
            <Select
              showSearch
              style={{ width: 200 }}
              placeholder="Select a reason"
              value={dispenser_size}
              optionFilterProp="children"
              onChange={(value) => this.handleDispenserSizeChange(value)}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {dispenserSizeOption}
            </Select>
          ),
      },
      {
        title: "Action",
        render: (record) => (
          <span>
            {Number(edit_order_id) !== Number(record.id) ? (
              <Tooltip placement="top" title="Edit">
                <span>
                  <a onClick={() => this.onOrderEdit(record)} role="button">
                    <Icon type="edit" />
                  </a>
                </span>
              </Tooltip>
            ) : (
              <Tooltip placement="top" title="Save">
                <span>
                  <a onClick={() => this.onOrderSave(record)} role="button">
                    <Icon type="save" />
                  </a>
                </span>
              </Tooltip>
            )}

            <Divider type="vertical" />

            <Tooltip placement="top" title="Delete Order">
              <span
                onClick={() => this.showDeleteConfirm(record.id)}
                role="button"
              >
                <a>
                  <Icon type="delete" style={{ color: "red" }} />
                </a>
              </span>
            </Tooltip>
          </span>
        ),
      },
    ];

    return (
      <div style={{ width: "90%", margin: "auto", marginTop: "5%" }}>
        <h2 style={{ textAlign: "center" }}>All Orders</h2>
        <hr width="100px" />

        <Row type="flex" justify="center">
          <Col>
            <RadioGroup
              onChange={this.onSearchChange}
              value={selectSearchOption}
            >
              <RadioButton value="name">Name</RadioButton>
              <RadioButton value="mobile">Mobile</RadioButton>
            </RadioGroup>
          </Col>

          <Col style={{ marginLeft: "10px" }}>
            <Search
              className="m-auto"
              enterButton
              value={searchValue}
              onChange={(event) => this.changeSubmitValue(event)}
              placeholder="Name/Mobile"
              onSearch={(value) => this.onSearchSubmit(value)}
              style={{ width: 300 }}
            />
          </Col>
        </Row>

        <Table
          style={{ marginTop: "5%" }}
          dataSource={orders}
          columns={columns}
          loading={loading}
          bordered
          pagination={false}
          scroll={{ x: 2300 }}
          size="small"
          rowKey="id"
        />
        <br />

        {!searchValue ? (
          <Pagination
            style={{ float: "right" }}
            showSizeChanger
            onShowSizeChange={this.onShowSizeChange}
            defaultCurrent={pageNo}
            total={orderLength}
            onChange={_.debounce(this.onChange, 300)}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  orders: state.OrderState.orders,
  partners: state.OrderState.partners,
  medicineList: state.AppState.medicineList,
  pageNo: state.OrderState.pageNo,
  pageSize: state.OrderState.pageSize,
});
const mapDispatchToProps = (dispatch) => ({
  setOrders: (data) => dispatch({ type: SET_FETCH_ORDER, payload: { data } }),
  setOrderValuesInStore: (data) =>
    dispatch({ type: ADD_PATIENT_DETAILS, data }),
  updateOrder: (indexAt, data) =>
    dispatch({ type: UPDATE_ORDER, payload: { indexAt, data } }),
  setPartners: (data) =>
    dispatch({ type: SET_FETCH_PARTNERS, payload: { data } }),
  setCurrenetPageAndSize: (pageNo, pageSize) =>
    dispatch({ type: SETCURRENTPAGEANDSIZE, payload: { pageNo, pageSize } }),
});

export default connect(mapStateToProps, mapDispatchToProps)(FetchOrderList);



// WEBPACK FOOTER //
// ./src/component/FetchOrderList/FetchOrderList.js